import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { BRAND } from "../data/content";

export default function Community() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (!valid) {
      toast.error("Enter a valid email to receive transmissions.");
      return;
    }
    setDone(true);
    toast.success("You\u2019re inside the world of H.\u039B.R.V.E.R.");
    setEmail("");
  };

  return (
    <section id="community" className="relative w-full py-28 md:py-44 px-5 md:px-10 overflow-hidden" data-testid="section-community">
      <div className="absolute inset-0" aria-hidden>
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[60vw] h-[50vh] rounded-full blur-[140px] opacity-25"
          style={{ background: "radial-gradient(closest-side, rgba(185,189,196,0.35), transparent)" }} />
      </div>

      <div className="max-w-3xl mx-auto relative text-center">
        <motion.p
          className="track-label text-white/50 mb-6"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}
        >
          EMAIL \u2014 COMMUNITY
        </motion.p>
        <motion.h2
          className="font-display chrome-text text-4xl sm:text-5xl md:text-7xl leading-[0.95] mb-6"
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          ENTER THE WORLD<br />OF {BRAND.name}
        </motion.h2>
        <motion.p
          className="font-body text-white/55 text-base md:text-lg mb-10"
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }}
        >
          Music. Visuals. Releases. Limited drops. No noise.
        </motion.p>

        {done ? (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
            className="glass max-w-md mx-auto px-8 py-6"
            data-testid="community-success"
          >
            <p className="font-display steel-text text-2xl mb-1">Signal locked.</p>
            <p className="font-body text-white/50 text-sm">You\u2019ll be first to receive every transmission.</p>
          </motion.div>
        ) : (
          <motion.form
            onSubmit={submit}
            noValidate
            className="flex flex-col sm:flex-row max-w-md mx-auto gap-3"
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.3 }}
            data-testid="community-form"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid="community-email"
              className="flex-1 bg-transparent border border-white/20 px-5 py-4 text-white placeholder:text-white/30 font-body text-sm focus:outline-none focus:border-white transition-colors duration-300"
            />
            <button
              type="submit"
              data-testid="community-join"
              data-cursor
              className="px-9 py-4 bg-white text-black track-label hover:bg-white/80 transition-colors duration-300"
            >
              JOIN
            </button>
          </motion.form>
        )}
      </div>
    </section>
  );
}
